<div class="app-container flex-column">
    <header class="app-header">
        <div class="header-content">
            <div class="header-left">
                <img src="https://d9p7civm2914u.cloudfront.net/wp-content/uploads/2019/10/wgu-logo-1024x227.png"
                    alt="WGU Logo" class="wgu-logo" />
                <button (click)="saveAndExit()" class="nav-button plain" [disabled]="isSaving">
                    <span class="flex align-center">
                        <mat-icon fontIcon="chevron_left"></mat-icon>
                        Save and Return to EMA
                    </span>
                </button>
            </div>
        </div>
    </header>
    <app-banner *ngIf="failedToExit" class="full-width"
        message="Failed to close this browser tab. Your changes have been saved successfully, you may manually exit this tab and return to EMA."
        icon="error_outline" variant="error"></app-banner>
    <app-banner *ngIf="allAspectsCompleted" class="full-width"
        message="All aspects have been reviewed and saved - You may save and return to EMA." icon="check"></app-banner>
    <app-banner *ngIf="hasError" class="full-width"
        message="An error occurred with this submission - select Save and Return to EMA to complete this evaluation."
        icon="error_outline" variant="error"></app-banner>

    <main class="main-content">
        <section class="aspects-panel flex-column">
            <div class="flex-column flex-grow">
                <app-aspect-evaluation-group #aspectGroup (finished)="aspectAnalysisComplete()"
                    (activeAspectChange)="updateActiveAspects($event)" (initialized)="aspectGroupInitialized()"
                    (showPreviouslyCompleted)="toggleAspectVisibility($event)" (showAllAspects)="showAllAspects"
                    class="aspects-group-container flex-column" *ngIf="!isLoading" [allowMultipleSectionsOpen]="false">
                    <app-aspect-evaluation *ngFor="let aspect of displayedAspects"
                        class="flex-grow fit-content full-height flex" [aspect]="aspect"
                        (aspectChange)="onAspectChange($event)" (isTyping)="isSaving = true;">
                    </app-aspect-evaluation>
                </app-aspect-evaluation-group>
            </div>
        </section>

        <section class="file-viewer-panel" *ngIf="!isLoading">
            <div class="flex mb-2 justify-end flex-gap_10 progress-save align-center">
                <!-- Saving in progress -->
                <ng-container *ngIf="isSaving; else notSaving">
                    <mat-icon fontIcon="sync"></mat-icon>
                    <span>Saving...</span>
                </ng-container>

                <!-- Not saving state -->
                <ng-template #notSaving>
                    <!-- Save success -->
                    <ng-container *ngIf="failedSaveAspectsList.length === 0; else saveFailed">
                        <mat-icon fontIcon="save"></mat-icon>
                        <span>Progress Saved</span>
                    </ng-container>

                    <!-- Save failed -->
                    <ng-template #saveFailed>
                        <span class="error-text">Some changes were not saved.</span>
                        <button (click)="retryFailedSaves()" class="nav-button error">
                            Try Again
                        </button>
                    </ng-template>
                </ng-template>
            </div>

            <app-file-viewer [activeAspectIds]="activeAspectIds" [files]="submission?.files || []">
            </app-file-viewer>
        </section>
    </main>
</div>